import './global.css'
import './src/styles/index.scss'
// import './index.scss'

